import { Grid, Typography, useTheme } from '@mui/material';
import { percentageToTwoDecimalPlacesNoHundred } from '../../../../../utilities/numberFormatters';
import MoabTableComponent from './sharedTable.component';
import TableWrapper from './tableWrapper';
import { MoabReport } from '../moab.types';

interface CurrencyAssetsTableProps {
  title: string;
  data: MoabReport;
  baseOrAll: 'base' | 'all';
  fundId: string;
}
const MOAB_TABLE_TITLES = ['M0', 'M1', 'M2', 'M3'];
const MOAB_TABLE_SUBTITLES = [
  'Cash',
  'Cash, Govt T-Bills',
  'Cash, All Govt Bonds',
  'All 1-Day Liquidation Assets',
];
const CurrencyAssetsTable = (props: CurrencyAssetsTableProps) => {
  const dataKey =
    props.baseOrAll === 'base' ? 'base_currency_data' : 'all_currency_data';

  const report = props.data;
  const theme = useTheme();
  return (
    <TableWrapper>
      <Typography
        variant="h2"
        style={{
          color: theme.palette.primary.main,
          fontWeight: 400,
          margin: '0.62rem',
          marginLeft: '0.94rem',
        }}
      >
        {props.title}
      </Typography>
      <Grid container>
        {MOAB_TABLE_TITLES.map((title, index) => {
          return (
            <Grid
              key={title}
              item
              xs={3}
              style={{
                alignSelf: 'stretch',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography
                variant="h3"
                style={{
                  paddingLeft: 16,
                  fontWeight: 400,
                  fontSize: '1.25rem',
                }}
              >
                {`${title} : ${percentageToTwoDecimalPlacesNoHundred(
                  report?.[dataKey]?.[index]?.[0] ?? 0,
                )}`}
              </Typography>
              <MoabTableComponent
                identifier={title}
                fundId={props.fundId}
                positionDate={report?.selected_position_date ?? ''}
                title={MOAB_TABLE_SUBTITLES[index]}
                data={report?.[dataKey]?.[index]?.[1] ?? []}
              />
            </Grid>
          );
        })}
      </Grid>
    </TableWrapper>
  );
};

export default CurrencyAssetsTable;
